export default "__VITE_ASSET__CyzQIhsK__"